<template>
  <div style="padding: 20px;">
    <button
      class="button gray"
      @click="$router.go(-1)"
      style="margin-bottom: 20px;">
      <font-awesome-icon
        class="icon"
        :icon="['fas', 'arrow-left']"
      />
      Retour
    </button>

    <LoaderView v-if="recipe == null" />

    <div v-else>
      <DishCard
        :recipe="recipe"
        @update="recipe = $event"
      />
    </div>
  </div>
</template>

<script>

import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import DishCard from "@/views/DishCard.vue";

export default {
  name: "RecipeView",
  components: {
    LoaderView,
    DishCard,
  },
  data() {
    return {
      recipe: null,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      api.get(`/recipes/${this.id}/`).then((response) => {
        this.recipe = response.data.recipe || response.data;
      });
    },
  }
};

</script>


<style scoped>


</style>
